import React from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from '../ui';

// Branded split-screen shell for auth pages (login / vendor login).
// Left: deep-blue brand panel (desktop). Right: form card. UI only.
const AuthShell = ({ title, subtitle, side, children }) => (
  <div className="min-h-screen flex bg-ink-50">
    {/* Brand panel */}
    <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-brand-900 text-white">
      <div className="absolute inset-0 bg-brand-mesh opacity-90" />
      <div className="relative flex flex-col justify-between p-12 w-full">
        <Link to="/"><BrandMark layout="horizontal" className="h-8 text-white" /></Link>
        <div>
          <h2 className="text-3xl xl:text-4xl font-extrabold font-display leading-tight max-w-md">
            {side?.heading || 'Digital ticketing built for school districts.'}
          </h2>
          <p className="mt-3 text-brand-100 max-w-sm">
            {side?.sub || 'Athletics, fine arts, tournaments and community events, all in one branded platform.'}
          </p>
          <ul className="mt-6 space-y-2.5 text-brand-100 text-sm">
            {(side?.bullets || ['Instant mobile QR tickets', 'Scan-in at the gate', 'Real-time district reporting']).map((b) => (
              <li key={b} className="flex items-center gap-2"><span className="text-accent-400">✓</span>{b}</li>
            ))}
          </ul>
        </div>
        <Link to="/demo" className="text-accent-300 text-sm font-medium hover:text-accent-200">Explore district demos →</Link>
      </div>
    </div>

    {/* Form side */}
    <div className="flex-1 flex flex-col min-h-screen">
      <div className="lg:hidden p-6">
        <Link to="/"><BrandMark layout="horizontal" className="h-7 text-brand-800" /></Link>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="mb-6 text-center lg:text-left">
            <h1 className="text-2xl font-bold font-display text-ink-900">{title}</h1>
            {subtitle && <p className="mt-1 text-ink-500 text-sm">{subtitle}</p>}
          </div>
          <div className="bg-white rounded-2xl shadow-card border border-ink-100 p-6 sm:p-8">
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthShell;
